"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsContext = void 0;
var _react = require("react");
/**
 * Context values for translations in an application.
 * @typeParam T Type of translations object
 */

const defaultValues = {
  translationsWithNamespaces: {},
  defaultTranslationsWithNamespaces: {},
  language: '',
  /** @deprecated Use @see {language} */
  currentLanguage: '',
  // eslint-disable-next-line no-console -- its just a default value
  clientFetchConfiguration: {
    baseUrl: '',
    tenant: '',
    onError: error => console.error(error)
  }
};
const translationsContext = exports.translationsContext = /*#__PURE__*/(0, _react.createContext)(defaultValues);
//# sourceMappingURL=translationsContext.js.map